import { format } from "date-fns";
import moment from "moment";
import intl from "react-intl-universal";
import { downloadCsv } from "../../../Components/Molecules/GridHistory/gridFilterUtils";
import {
  EMPTY_DATE_AMOUNT_SUB_ACCOUNT_FILTERS,
  apiFilterObjFromFilters,
  buildDateAmountSubAccountFilterTags,
  filtersFromApiFilterObj,
  hasActiveDateAmountSubAccountFilters,
  isDateAmountSubAccountChipFilterActive,
  removeDateAmountSubAccountFilterTag,
} from "../../../Components/Molecules/GridHistory/dateAmountSubAccountFilters";

export const EMPTY_TRANSFERS_FILTERS = { ...EMPTY_DATE_AMOUNT_SUB_ACCOUNT_FILTERS };

export {
  apiFilterObjFromFilters as transfersFilterObjFromFilters,
  buildDateAmountSubAccountFilterTags as buildTransfersFilterTags,
  filtersFromApiFilterObj as filtersFromTransfersFilterObj,
  hasActiveDateAmountSubAccountFilters as hasActiveTransfersFilters,
  isDateAmountSubAccountChipFilterActive as isTransfersChipFilterActive,
  removeDateAmountSubAccountFilterTag as removeTransfersFilterTag,
};

export const exportTransfersCsv = (items) => {
  const headers = [
    intl.get("grid.recipient"),
    intl.get("grid.date"),
    intl.get("grid.value"),
    intl.get("grid.entry"),
  ];

  const rows = (items ?? []).map((item) => [
    item?.receiver?.name || "",
    moment(item?.created_at).format("DD/MM/YYYY HH:mm"),
    String(Number(item?.amount ?? 0)).replace(".", ","),
    item?.description || "",
  ]);

  downloadCsv(headers, rows, `transferencias-${format(new Date(), "yyyy-MM-dd")}.csv`);
};
